import { c as _c } from "react/compiler-runtime";
import type { JiraIssue } from '@/lib/jira/types';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useDebounceValue } from 'usehooks-ts';
export function useJiraIssueSearch(installationId) {
  const $ = _c(14);
  const [search, setSearch] = useState("");
  const [debouncedSearch] = useDebounceValue(search, 300);
  let t0;
  if ($[0] !== debouncedSearch || $[1] !== installationId) {
    t0 = ["jira-search", debouncedSearch, installationId];
    $[0] = debouncedSearch;
    $[1] = installationId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = t0 as const;
  const t2 = debouncedSearch.length > 0 && !!installationId;
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = {
      queryKey: t1,
      queryFn: _temp,
      placeholderData: _temp2,
      enabled: t2,
      staleTime: 10000,
      gcTime: 10000,
      refetchOnWindowFocus: false
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data,
    isLoading,
    error
  } = useQuery(t3);
  let t4;
  if ($[6] !== data?.issues) {
    t4 = data?.issues || [];
    $[6] = data?.issues;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = error?.message || "";
  let t6;
  if ($[8] !== debouncedSearch || $[9] !== isLoading || $[10] !== search || $[11] !== t4 || $[12] !== t5) {
    t6 = {
      search,
      setSearch,
      debouncedSearch,
      searchResults: t4,
      isLoading,
      error: t5
    };
    $[8] = debouncedSearch;
    $[9] = isLoading;
    $[10] = search;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp2() {}
async function _temp(t0) {
  const {
    signal,
    queryKey
  } = t0;
  const [, term, resolvedInstallationId] = queryKey as readonly [string, string, number];
  const res = await fetch(`/api/jira/issue/search?term=${encodeURIComponent(term)}&installationId=${resolvedInstallationId}`, {
    signal
  });
  if (!res.ok) {
    throw new Error("Failed to search Jira issues");
  }
  return res.json();
}